
interface StatsCardProps {
  title: string;
  value: string | number;
  icon: string;
  color: 'blue' | 'green' | 'purple' | 'orange' | 'red' | 'indigo' | 'teal';
}

export default function StatsCard({ title, value, icon, color }: StatsCardProps) {
  const colorClasses = {
    blue: 'bg-blue-100 text-blue-800 border-blue-300',
    green: 'bg-green-100 text-green-800 border-green-300', 
    purple: 'bg-purple-100 text-purple-800 border-purple-300',
    orange: 'bg-orange-100 text-orange-800 border-orange-300',
    red: 'bg-red-100 text-red-800 border-red-300',
    indigo: 'bg-indigo-100 text-indigo-800 border-indigo-300',
    teal: 'bg-teal-100 text-teal-800 border-teal-300'
  };

  const iconColorClasses = {
    blue: 'text-blue-700',
    green: 'text-green-700',
    purple: 'text-purple-700',
    orange: 'text-orange-700',
    red: 'text-red-700',
    indigo: 'text-indigo-700',
    teal: 'text-teal-700'
  };

  const iconBgClasses = {
    blue: 'bg-blue-200',
    green: 'bg-green-200',
    purple: 'bg-purple-200',
    orange: 'bg-orange-200',
    red: 'bg-red-200',
    indigo: 'bg-indigo-200',
    teal: 'bg-teal-200'
  };

  return (
    <div className={`rounded-xl shadow-lg border-2 p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 ${colorClasses[color]}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium opacity-80 mb-1">{title}</p>
          <p className="text-2xl font-bold">{value}</p>
        </div>
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center shadow-md ${iconBgClasses[color]}`}>
          <i className={`${icon} text-xl ${iconColorClasses[color]}`}></i>
        </div>
      </div>
    </div>
  );
}
